import { MenuItem } from '../models/menu/menu.model';

export const rbfrsMenu: MenuItem[] = [];
